export default __webpack_public_path__ + "static/media/BaseTemplateImg.fcdd7702.png";